import React from 'react';
import './css/theme.css'; // design tokens — must load before component styles
import './css/motion.css'; // the app's shared entrances, built on those tokens
import './index.css';
import './css/Button.css'; // shared .qd-btn / .btn-* system (used app-wide)
import { createRoot } from 'react-dom/client';

import Root from './Root';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './context/ThemeContext';
import { FileBadgeProvider } from './context/FileBadgeContext';
import { NotificationProvider } from './context/NotificationContext';
import { ConfirmProvider } from './context/ConfirmContext';
import { installGlobalErrorHandlers } from './notifications/globalHandlers';

// Catch unhandled promise rejections and out-of-tree runtime errors and route
// them into the notification center (render errors stay with ErrorBoundary).
installGlobalErrorHandlers();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <NotificationProvider>
          <FileBadgeProvider>
            <ConfirmProvider>
              <Root />
            </ConfirmProvider>
          </FileBadgeProvider>
        </NotificationProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
